import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import {
    getTasksList,
    getTasksCount,
    listTask,
    createTask,
    createTaskSupport,
    updateTask,
    updateTaskSupport,
    deleteTask,
    deleteTaskSupport,
    getTaskById,
    changeSwimLanes,
    addRemoveComments,
    addRemoveMainTaskComments,
    addRemoveAttachments,
    addRemoveAttachmentsSupport,
    listSubTasks,
    listSubTasksSupport,
    listSubTasksMain,
    taskHistory,
    mainTaskHistory,
    getS3Url,
    listTaskSupport,
    importExcelTasks,
    listMainTasks,
    getMainTaskById,
    createMainTask,
    updateMainTask,
    deleteMainTask,
} from './tasks.service'

const initialCreateTask = {
    open: false,
    _id: '',
    text: '',
    loading: false,
    assigneeId: '',
}

const initialState = {
    search: '',
    status: 'loaded',
    initialLoading: true,
    historyStatus: 'loaded',
    taskStatus: 'loaded',
    tasks: [],
    subTasksList: [],
    taskFiles: [],
    historyTask: [],
    tasksCount: 0,
    isNextHistory: false,
    pageLimitHistory: 30,
    currentPageHistory: 1,
    skipPageHistory: 0,
    isNext: false,
    pageLimit: 100,
    currentPage: 1,
    skipPage: 0,
    formDrawer: false,
    viewDrawer: false,
    formModal: false,
    formSubTask: false,
    viewModal: false,
    pointerEvent: true,
    globalTimer: undefined,
    filterView: false,
    filterDropDown: {
        sprintId:
            // (localStorage.getItem('currentSprint') &&
            //     JSON.parse(localStorage.getItem('currentSprint'))?.id) ||
            '',
        assignee: [],
    },
    selectedTask: undefined,
    selectedSubTask: undefined,
    latestTaskDetailRequestId: null,
    selectedFormat: 'cards',
    fileError: '',
    taskListWithoutType: [],
    createTaskBoard: initialCreateTask,
    // Project detail task list state
    projectTaskList: [],
    projectTaskListStatus: 'loaded',
    projectTaskListPage: 1,
    projectTaskListIsNext: false,
    // Development / main-task board (parallel to support list)
    projectMainTaskList: [],
    projectMainTaskListStatus: 'loaded',
    projectMainTaskListPage: 1,
    projectMainTaskListIsNext: false,
}

export const tasksList = createAsyncThunk(
    'tasksSlice/getTasksList',
    async (payload) => {
        const response = await getTasksList(payload)
        return response
    }
)

export const totalTasks = createAsyncThunk(
    'tasksSlice/getTasksCount',
    async (payload) => {
        const response = await getTasksCount(payload)
        return response
    }
)
export const taskList = createAsyncThunk(
    'tasksSlice/listTask',
    async (payload) => {
        const response = await listTask(payload)
        return response
    }
)
export const getSubTaskList = createAsyncThunk(
    'tasksSlice/listSubTasks',
    async (payload) => {
        const response = await listSubTasks(payload)
        return response
    }
)

export const getSubTaskListSupport = createAsyncThunk(
    'tasksSlice/listSubTasksSupport',
    async (payload) => {
        const response = await listSubTasksSupport(payload)
        return response
    }
)

export const getSubTaskListMain = createAsyncThunk(
    'tasksSlice/listSubTasksMain',
    async (payload) => {
        const response = await listSubTasksMain(payload)
        return response
    }
)

export const taskListSupport = createAsyncThunk(
    'tasksSlice/listTaskSupport',
    async (payload = {}, { rejectWithValue }) => {
        try {
            const response = await listTaskSupport(payload)
            return response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const mainTaskList = createAsyncThunk(
    'tasksSlice/mainTaskList',
    async (payload = {}, { rejectWithValue }) => {
        try {
            const response = await listMainTasks(payload)
            return response
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)

export const mainTaskById = createAsyncThunk(
    'tasksSlice/mainTaskById',
    async (payload) => {
        const id = payload?._id ?? payload?.taskId
        const response = await getMainTaskById(id)
        return response
    }
)

export const mainTaskCreate = createAsyncThunk(
    'tasksSlice/mainTaskCreate',
    async (payload) => {
        const response = await createMainTask(payload)
        return response
    }
)

export const mainTaskUpdate = createAsyncThunk(
    'tasksSlice/mainTaskUpdate',
    async (payload) => {
        const { id, body } = payload
        const response = await updateMainTask({ id, body })
        return response
    }
)

export const mainTaskDelete = createAsyncThunk(
    'tasksSlice/mainTaskDelete',
    async (id) => {
        const response = await deleteMainTask(id)
        return response
    }
)

export const taskCreate = createAsyncThunk(
    'tasksSlice/createTask',
    async (payload) => {
        const response = await createTask(payload)
        return response
    }
)

export const taskCreateSupport = createAsyncThunk(
    'tasksSlice/createTaskSupport',
    async (payload) => {
        const response = await createTaskSupport(payload)
        return response
    }
)

export const taskUpdateSupport = createAsyncThunk(
    'tasksSlice/updateTaskSupport',
    async (payload) => {
        const response = await updateTaskSupport(payload)
        return response
    }
)

export const taskUpdate = createAsyncThunk(
    'tasksSlice/updateTask',
    async (payload) => {
        const response = await updateTask(payload)
        return response
    }
)
export const taskDelete = createAsyncThunk(
    'tasksSlice/deleteTask',
    async (payload) => {
        const response = await deleteTask(payload)
        return response
    }
)

export const taskDeleteSupport = createAsyncThunk(
    'tasksSlice/deleteTaskSupport',
    async (payload) => {
        const response = await deleteTaskSupport(payload)
        return response
    }
)
export const taskById = createAsyncThunk(
    'tasksSlice/getTaskById',
    async (payload) => {
        const response = await getTaskById(payload)
        return response
    }
)
export const swiLaneUpdate = createAsyncThunk(
    'tasksSlice/changeSwimLanes',
    async (payload) => {
        const response = await changeSwimLanes(payload)
        return response
    }
)
export const updateComment = createAsyncThunk(
    'tasksSlice/addRemoveComments',
    async (payload) => {
        const response = await addRemoveComments(payload)
        return response
    }
)

export const updateMainTaskComment = createAsyncThunk(
    'tasksSlice/mainTaskComments',
    async (payload) => {
        const response = await addRemoveMainTaskComments(payload)
        return response
    }
)

export const updateAttachments = createAsyncThunk(
    'tasksSlice/addRemoveAttachments',
    async (payload) => {
        const response = await addRemoveAttachments(payload)
        return response
    }
)

export const updateAttachmentsSupport = createAsyncThunk(
    'tasksSlice/addRemoveAttachmentsSupport',
    async (payload) => {
        const response = await addRemoveAttachmentsSupport(payload)
        return response
    }
)
export const historyTaskGet = createAsyncThunk(
    'tasksSlice/taskHistory',
    async (id) => {
        const response = await taskHistory(id)
        return response
    }
)

export const mainHistoryTaskGet = createAsyncThunk(
    'tasksSlice/mainTaskHistory',
    async (id) => {
        const response = await mainTaskHistory(id)
        return response
    }
)

export const getS3UrlForAttachment = createAsyncThunk(
    'tasksSlice/getS3Url',
    async (payload) => {
        const response = await getS3Url(payload)
        return response
    }
)

export const importExcelTasksThunk = createAsyncThunk(
    'tasksSlice/importExcelTasks',
    async (payload) => {
        const response = await importExcelTasks(payload)
        return response
    }
)

export const tasksSlice = createSlice({
    name: 'tasksSlice',
    initialState,
    reducers: {
        switchFormModal: (state, action) => {
            state.selectedTask = undefined
            state.formModal = action.payload.open || false
        },
        taskFilesUpload: (state, action) => {
            state.taskFiles = [...state.taskFiles, action.payload]
        },
        taskFilesRemove: (state, action) => {
            state.taskFiles = action.payload
        },
        clearTaskFileUpload: (state) => {
            state.taskFiles = []
        },
        taskFileError: (state, action) => {
            state.fileError = action.payload
        },
        switchFormModalSubTask: (state, action) => {
            state.selectedSubTask = undefined
            state.formSubTask = action.payload.open ? true : false
        },
        setPointerEvent: (state, action) => {
            state.pointerEvent = action.payload
        },
        setGlobalTimer: (state, action) => {
            state.globalTimer = action.payload
        },
        selectTaskUpdate: (state, action) => {
            state.selectedTask = action.payload
        },
        selectSubTaskUpdate: (state, action) => {
            state.selectedSubTask = action.payload
        },
        updateSubTaskListItem: (state, action) => {
            const { subTaskId, updates } = action.payload || {}
            if (!subTaskId || !updates) return

            const index = state.subTasksList.findIndex(
                (item) => String(item?._id) === String(subTaskId)
            )
            if (index === -1) return

            state.subTasksList[index] = {
                ...state.subTasksList[index],
                ...updates,
            }
        },
        searchTasks: (state, action) => {
            state.search = action.payload
        },
        setTasks: (state, action) => {
            state.tasks = action.payload
        },
        switchFilter: (state, action) => {
            if (action.payload) {
                state.filterView = true
            } else {
                state.filterView = state.filterView ? false : true
            }
        },
        clearTasks: (state) => {
            state.search = ''
            state.tasks = []
            state.selectedTask = undefined
        },
        switchFormDrawer: (state, action) => {
            if (action.payload) state.selectedTask = undefined
            state.viewDrawer = false
            state.formDrawer = state.formDrawer ? false : true
        },
        switchFormat: (state) => {
            if (state.selectedFormat === 'cards') {
                state.selectedFormat = 'lists'
            } else {
                state.selectedFormat = 'cards'
            }
        },
        filterDropdown: (state, action) => {
            const dropDownValue = {
                ...state.filterDropDown,
                ...action.payload,
            }
            Object.keys(dropDownValue).forEach((key) => {
                if (dropDownValue[key] === '') {
                    delete dropDownValue[key]
                }
            })
            state.filterDropDown = dropDownValue
        },
        clearFilterDropDown: (state) => {
            // localStorage.setItem(
            //     'currentSprint',
            //     JSON.stringify({
            //         id: 'Backlog',
            //         name: 'Backlog',
            //     })
            // )
            state.filterDropDown = initialState.filterDropDown
        },
        clearHistoryTask: (state) => {
            state.historyStatus = 'loaded'
            state.historyTask = []
            state.isNextHistory = false
        },
        changePage: (state, action) => {
            state.currentPage = action.payload.currentPage
            state.skipPage = action.payload.skip
            state.pageLimit = action.payload.pageLimit
        },
        changeHistoryPage: (state, action) => {
            state.currentPageHistory = action.payload.currentPage
            state.skipPageHistory = action.payload.skip
            state.pageLimitHistory = action.payload.pageLimit
        },
        setCreateTask: (state, action) => {
            state.createTaskBoard = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(tasksList.pending, (state) => {
                state.status = 'loading'
            })
            .addCase(getSubTaskList.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.subTasksList = action.payload.data
            })
            .addCase(getSubTaskListSupport.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.subTasksList = action.payload.data
            })
            .addCase(getSubTaskListMain.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.subTasksList = action.payload.data
            })
            .addCase(tasksList.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.tasks = action.payload.data
            })
            .addCase(taskList.pending, (state) => {
                if (state.initialLoading) {
                    state.status = 'loading'
                }
            })
            .addCase(taskList.fulfilled, (state, action) => {
                state.status = 'loaded'
                state.initialLoading = false
                const payloadData = action?.payload?.data

                if (
                    Array.isArray(payloadData) &&
                    payloadData.length > 0 &&
                    payloadData[0]?.list
                ) {
                    // 🟢 Case: Grouped by status/columns
                    state.tasks = payloadData
                        .sort((a, b) => a.position - b.position)
                        .map((item) => ({
                            _id: item._id,
                            position: item?.position,
                            list: Array.isArray(item?.list)
                                ? item.list.sort(
                                      (a, b) => a.position - b.position
                                  )
                                : [],
                        }))

                    state.taskListWithoutType = [] // Reset the flat list in case of switch
                } else {
                    // 🔵 Case: Flat list (without type/group)
                    state.taskListWithoutType = Array.isArray(payloadData)
                        ? payloadData
                        : []
                    state.tasks = [] // Reset the grouped list in case of switch
                }
            })
            .addCase(historyTaskGet.pending, (state) => {
                state.historyStatus = 'loading'
            })
            .addCase(historyTaskGet.fulfilled, (state, action) => {
                state.historyStatus = 'loaded'
                state.historyTask = action.payload.data.data
                state.isNextHistory = action.payload.isNext
            })
            .addCase(mainHistoryTaskGet.pending, (state) => {
                state.historyStatus = 'loading'
            })
            .addCase(mainHistoryTaskGet.fulfilled, (state, action) => {
                state.historyStatus = 'loaded'
                state.historyTask = action.payload.data.data
                state.isNextHistory = action.payload.isNext
            })
            .addCase(totalTasks.fulfilled, (state, action) => {
                state.tasksCount = action.payload.data
            })
            .addCase(taskById.pending, (state, action) => {
                state.taskStatus = 'loading'
                state.latestTaskDetailRequestId =
                    action.meta?.arg?._id ?? action.meta?.arg?.taskId ?? null
            })
            .addCase(taskById.fulfilled, (state, action) => {
                state.taskStatus = 'loaded'
                const requestedId =
                    action.meta?.arg?._id ?? action.meta?.arg?.taskId
                if (
                    requestedId != null &&
                    state.latestTaskDetailRequestId != null &&
                    String(requestedId) !==
                        String(state.latestTaskDetailRequestId)
                ) {
                    return
                }

                if (action.payload?.data?.data) {
                    state.selectedTask = action?.payload?.data
                }
            })
            .addCase(taskListSupport.pending, (state) => {
                state.projectTaskListStatus = 'loading'
            })
            .addCase(taskListSupport.fulfilled, (state, action) => {
                state.projectTaskListStatus = 'loaded'
                const { skip = 0 } = action.meta.arg || {}

                // Handle response structure: { data: [...], isNext: false }
                const responseData = action.payload?.data ?? []
                const isNext = action.payload?.isNext ?? false
                const isGroupedResponse =
                    Array.isArray(responseData) &&
                    responseData.length > 0 &&
                    responseData[0]?.list

                const sortByPosition = (a, b) =>
                    Number(a?.position ?? 0) - Number(b?.position ?? 0)

                if (skip === 0) {
                    // Initial load - replace data (sorted by position)
                    if (isGroupedResponse) {
                        state.projectTaskList = [...responseData]
                            .sort(sortByPosition)
                            .map((group) => ({
                                ...group,
                                list: Array.isArray(group?.list)
                                    ? [...group.list].sort(sortByPosition)
                                    : [],
                            }))
                    } else {
                        state.projectTaskList = Array.isArray(responseData)
                            ? [...responseData].sort(sortByPosition)
                            : []
                    }
                    state.projectTaskListPage = 1
                } else {
                    // Loading more - merge tasks into existing groups
                    if (isGroupedResponse) {
                        // Grouped structure - merge tasks into existing groups
                        state.projectTaskList = state.projectTaskList
                            .map((existingGroup) => {
                                const matchingGroup = responseData.find(
                                    (newGroup) =>
                                        newGroup._id === existingGroup._id
                                )
                                if (matchingGroup && matchingGroup.list) {
                                    const mergedList = [
                                        ...(existingGroup.list || []),
                                        ...matchingGroup.list,
                                    ]
                                    return {
                                        ...existingGroup,
                                        list: mergedList.sort(sortByPosition),
                                    }
                                }
                                return existingGroup
                            })
                            .sort(sortByPosition)
                    } else {
                        // Flat structure - append data
                        state.projectTaskList = [
                            ...state.projectTaskList,
                            ...responseData,
                        ].sort(sortByPosition)
                    }
                    state.projectTaskListPage = state.projectTaskListPage + 1
                }

                state.projectTaskListIsNext = isNext
            })
            .addCase(taskListSupport.rejected, (state) => {
                state.projectTaskListStatus = 'error'
            })
            .addCase(mainTaskList.pending, (state) => {
                state.projectMainTaskListStatus = 'loading'
            })
            .addCase(mainTaskList.fulfilled, (state, action) => {
                state.projectMainTaskListStatus = 'loaded'
                const { skip = 0 } = action.meta.arg || {}

                const responseData = action.payload?.data ?? []
                const isNext = action.payload?.isNext ?? false
                const isGroupedResponse =
                    Array.isArray(responseData) &&
                    responseData.length > 0 &&
                    responseData[0]?.list

                const sortByPosition = (a, b) =>
                    Number(a?.position ?? 0) - Number(b?.position ?? 0)

                if (skip === 0) {
                    if (isGroupedResponse) {
                        state.projectMainTaskList = [...responseData]
                            .sort(sortByPosition)
                            .map((group) => ({
                                ...group,
                                list: Array.isArray(group?.list)
                                    ? [...group.list].sort(sortByPosition)
                                    : [],
                            }))
                    } else {
                        state.projectMainTaskList = Array.isArray(responseData)
                            ? [...responseData].sort(sortByPosition)
                            : []
                    }
                    state.projectMainTaskListPage = 1
                } else {
                    if (isGroupedResponse) {
                        state.projectMainTaskList = state.projectMainTaskList
                            .map((existingGroup) => {
                                const matchingGroup = responseData.find(
                                    (newGroup) =>
                                        newGroup._id === existingGroup._id
                                )
                                if (matchingGroup && matchingGroup.list) {
                                    const mergedList = [
                                        ...(existingGroup.list || []),
                                        ...matchingGroup.list,
                                    ]
                                    return {
                                        ...existingGroup,
                                        list: mergedList.sort(sortByPosition),
                                    }
                                }
                                return existingGroup
                            })
                            .sort(sortByPosition)
                    } else {
                        state.projectMainTaskList = [
                            ...state.projectMainTaskList,
                            ...responseData,
                        ].sort(sortByPosition)
                    }
                    state.projectMainTaskListPage =
                        state.projectMainTaskListPage + 1
                }

                state.projectMainTaskListIsNext = isNext
            })
            .addCase(mainTaskList.rejected, (state) => {
                state.projectMainTaskListStatus = 'error'
            })
            .addCase(mainTaskById.pending, (state, action) => {
                state.taskStatus = 'loading'
                const requestedId =
                    action.meta?.arg?._id ??
                    action.meta?.arg?.taskId ??
                    action.meta?.arg
                if (requestedId != null && requestedId !== '') {
                    state.latestTaskDetailRequestId = String(requestedId)
                }
            })
            .addCase(mainTaskById.fulfilled, (state, action) => {
                state.taskStatus = 'loaded'
                const requestedId =
                    action.meta?.arg?._id ??
                    action.meta?.arg?.taskId ??
                    action.meta?.arg
                if (
                    requestedId != null &&
                    state.latestTaskDetailRequestId &&
                    String(requestedId) !==
                        String(state.latestTaskDetailRequestId)
                ) {
                    return
                }
                const raw = action.payload?.data
                const task = raw?.data ?? raw
                if (task && (task._id || task.id)) {
                    const normalized = task._id
                        ? task
                        : { ...task, _id: task.id }
                    state.selectedTask = {
                        data: normalized,
                        _id: normalized._id,
                    }
                }
            })
    },
})

export default tasksSlice.reducer

/** Return the slice reference — never rebuild an object (avoids rerender warnings). */
export const tasksState = (state) => state.tasksSlice || initialState

export const {
    switchFormModal,
    switchFormModalSubTask,
    switchFilter,
    switchViewModal,
    searchTasks,
    setTasks,
    clearTasks,
    filterDropdown,
    switchFormDrawer,
    clearFilterDropDown,
    clearHistoryTask,
    changePage,
    selectTaskUpdate,
    selectSubTaskUpdate,
    updateSubTaskListItem,
    setGlobalTimer,
    setPointerEvent,
    changeHistoryPage,
    taskFilesUpload,
    clearTaskFileUpload,
    taskFilesRemove,
    taskFileError,
    setCreateTask,
} = tasksSlice.actions

/** Reset pagination and reload task history (support or main). */
export const refreshTaskHistory =
    (taskId, taskListKind = 'support') =>
    async (dispatch, getState) => {
        if (!taskId) return

        const { pageLimitHistory } = getState().tasksSlice
        dispatch(clearHistoryTask())
        dispatch(
            changeHistoryPage({
                currentPage: 1,
                skip: 0,
                pageLimit: pageLimitHistory,
            })
        )
        const fetchHistory =
            taskListKind === 'main' ? mainHistoryTaskGet : historyTaskGet
        await dispatch(fetchHistory(taskId))
    }
